import { render, staticRenderFns } from "./UsersPrivilegeBranches.vue?vue&type=template&id=fa86ebe8&scoped=true&"
import script from "./UsersPrivilegeBranches.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeBranches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa86ebe8",
  null
  
)

export default component.exports